var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({class:_vm.compClass,attrs:{"small":"","text":"","icon":"","color":"green","disabled":_vm.isDisabled},on:{"click":_vm.clicked}},on),[_c('v-icon',[_vm._v("cached")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.hint))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }